import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BASE}/api` });
export { BASE };

export const adminHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("wouffa_admin_token") || ""}`,
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return "Une erreur est survenue. Réessayez.";
}

export const SITE_URL = typeof window !== "undefined" ? window.location.origin : BASE;

export const openChat = (prefill = "") =>
  window.dispatchEvent(new CustomEvent("wouffa:open-chat", { detail: { prefill } }));

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const authWithGoogle = () => {
  const redirectUrl = window.location.origin + "/admin";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
